import api from 'api'
import { defaultHandleError } from 'util/downloadFile'
import { previewFile } from 'util/previewFile'

import { ImpressaoAcompanhamentoPreNatalInput } from './ImpressaoAcompanhamentoPreNatalInput'

export const downloadAcompanhamentoPreNatal = async (value: ImpressaoAcompanhamentoPreNatalInput) => {
  return await api.acompanhamentoPreNatal
    .imprimirAcompanhamentoPreNatal(value)
    .then((response) => {
      previewFile(new Blob([response.data], { type: 'application/pdf' }), 'Imprimir acompanhamento de pré-natal')
      return response
    })
    .catch(defaultHandleError)
}
